
import React, { useState } from 'react'
import GoogleLoginButton from './GoogleLoginButton';
import { toast } from 'react-toastify';
import LoadingSpin from '../../LoadingSpin';
import { adminLoginService } from '../../services/adminLoginService.js';
import { useAuth } from '../../context/auth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
   const { storeGooleAuthToken, getGoogleAuthToken, getAdminAuthToken, storeAdminAuthToken } = useAuth();
  // const [email, setEmail] = useState(false)
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)
  const googleToken = getGoogleAuthToken();
  const navigate = useNavigate()


  console.log("login component mount")


  //  const validUser = (email = '', passwod = '') => {
  //       if (!email || !passwod) {
  //           return "Email and password are required";
  //       }
  //       if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email)) {
  //           return "Invalid email format.";
  //       }

  //       return null;
  //   };

    const validPassword = (password = '') => {
  if (!password) {
    return "Password is required";
  }
  return null;
};


const handleLogin = async (e) => {
  e.preventDefault();


  const passwordError = validPassword(password);
  if (passwordError) {
    toast.error(passwordError);
    return;
  }

  setLoading(true);

  const data = {
    gs: googleToken,
    p: password,
  };

  try {
    // ✅ Call login API
    const response = await adminLoginService(data);

    if (response.status !== 200) {
      toast.error(response?.data?.data || "Something went wrong");
      setLoading(false);
      return;
    }

    const resData = response.data;

    // ✅ Handle API error case
    if (resData.error) {
      toast.error(
        <div className="p-4">
          <p className="mb-2 text-sm text-gray-800">
            {resData?.data || "Something went wrong."}
          </p>
        </div>
      );

      if (resData.mail_verification_error) {
        setLoading(false);
      }
      return;
    }

    // ✅ Success case
    if (resData.mail_verification_error === false) {
      const token = resData.data;

      if (!token) {
        toast.error("Invalid token received from server.");
        setLoading(false);
        return;
      }

      storeAdminAuthToken(token);

      // Optionally wait a bit before navigating
      setTimeout(() => {
        navigate("/dashboard/home");
      }, 1000);
    } else {
      toast.error(resData?.data || "Mail verification failed.");
    }

  } catch (error) {
    // ✅ Handle request errors
    toast.error(error?.response?.data?.data || "Something went wrong");
  } finally {
    // ✅ Always stop loading
    setLoading(false);
  }
};




const handleLogin1 = ()=>{
  navigate("/dashboard/home")
}






   return (
    <div className='w-screen '>
    <div className="min-h-screen w-full flex flex-col md:flex-row">
      {/* Left Section - Image or Gradient */}
      <div className="hidden md:flex w-1/2 bg-gradient-to-br from-blue-600 to-purple-600 items-center justify-center text-white p-10">
        <div className="text-center">
          <h1 className="text-4xl font-bold mb-4">Welcome Back!</h1>
          <p className="text-lg opacity-90">Sign in to continue your journey</p>
        </div>
      </div>

      {/* Right Section - Login Form */}
      <div className="flex flex-1 items-center justify-center p-6 bg-gray-50">
        <div className="w-full max-w-sm flex flex-col justify-center bg-white shadow-lg rounded-2xl p-8">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-6">Login</h2>

          {/* Google Button */}
          {/* <button className="w-full flex items-center justify-center border border-gray-300 rounded-lg py-2 hover:bg-gray-100 transition">
        
            <span>Sign in with Google</span>
          </button> */}
          <GoogleLoginButton></GoogleLoginButton>
{/* 
          <div className="flex items-center my-4">
            <hr className="flex-grow border-gray-300" />
            <span className="px-3 text-gray-500 text-sm">or</span>
            <hr className="flex-grow border-gray-300" />
          </div> */}

       
          {/* Password Input */}
          <div className="mb-4 mt-4">
            <label className="block text-sm text-gray-700 mb-1">Password</label>
            <input
              type="password"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="********"
              value={password}
            
              onChange={(e)=>setPassword(e.target.value)}
            />
          </div>
          <div className="mb-4 mt-4">
  <input
    type="text"
    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    placeholder="gs"
    value={
      googleToken
        ? googleToken.slice(0, 5) + '*'.repeat(googleToken.length - 3)
        : ''
    }
    readOnly
  />
</div>

          {/* Forgot Password + Login */}
          <div className="flex justify-between items-center mb-4">
            <a href="#" className="text-sm text-blue-600 hover:underline">
              Forgot password?
            </a>
          </div>
          <div className='w-full flex flex-col justify-center items-center '>

            <button
            onClick={handleLogin}
                            type='submit'
                            className="bg-blue-500 rounded-md w-44 py-2 px-1 text-white "
                            disabled={loading}
                        >
                            {loading ? <div className="spinner-wrapper"><LoadingSpin /></div> : 'Login'}
                        </button>
      
        
        </div>
        </div>
      </div>
    </div>
    </div>
  );
}

export default Login